import _ from 'lodash';
import { JSONSafeStringify } from './Micro';
// =======================================================================================================
let __MagicCode__ = "Magic. Do not touch";
let __STATE_STORAGE_VERSION__ = "0.0.4";
let __GLOBAL_STATE_KEY__ = "__GLOBAL_STATE__";
// =======================================================================================================
export interface StateStorageInfo {
    Version: string;
    MagicCode: string;
    Storage: { [key: string]: any },
    Timestamp: { [key: string]: any },
}
// =======================================================================================================
export class StateStorage {
    // --------------------------------------------------------------------------------------------
    public static GetInstance(): StateStorage {
        let state = (window as any).__STATE_STORAGE__;
        if (state == undefined) {
            state = new StateStorage(__GLOBAL_STATE_KEY__);
            (window as any).__STATE_STORAGE__ = state;
        }
        return state;
    };
    // --------------------------------------------------------------------------------------------
    private state: StateStorageInfo;
    private key: string;
    // --------------------------------------------------------------------------------------------
    constructor(key: string) {
        this.key = key;
        // Load any old states for the given key
        var data: StateStorageInfo = JSON.parse(sessionStorage.getItem(key));
        if (data == null ||
            data.Version !== __STATE_STORAGE_VERSION__ ||
            data.MagicCode !== __MagicCode__) {
            // Failed to find a correct one
            // we just create a new one
            data = {
                MagicCode: __MagicCode__,
                Version: __STATE_STORAGE_VERSION__,
                Storage: {},
                Timestamp: {}
            }
        }
        this.state = data;
        this.SaveToSession();
    }
    // --------------------------------------------------------------------------------------------
    public SaveToSession() {
        sessionStorage.setItem(this.key, JSONSafeStringify(this.state));
    }
    // --------------------------------------------------------------------------------------------
    public GetState(key: string): any | null {
        if (_.has(this.state.Storage, key))
            return this.state.Storage[key];
        return null;
    }
    // --------------------------------------------------------------------------------------------
    public GetStateWithTimestamp(key: string): { data: any, timestamp: number } | null {
        if (_.has(this.state.Storage, key))
            return { data: this.state.Storage[key], timestamp: this.state.Timestamp[key] };
        return null;
    }
    // --------------------------------------------------------------------------------------------
    public SetState(key: string, data: any) {
        this.state.Storage[key] = data;
        this.state.Timestamp[key] = Date.now();
        this.SaveToSession();
    }
    // --------------------------------------------------------------------------------------------
    public RemoveState(key: string) {
        if (_.has(this.state.Storage, key)) {
            this.state.Storage[key] = undefined;
            this.state.Timestamp[key] = undefined;
            this.SaveToSession();
        }
    }
    // --------------------------------------------------------------------------------------------
    public ClearAll() {
        this.state.Storage = {};
        this.state.Timestamp = {};
        this.SaveToSession();
    }
    // --------------------------------------------------------------------------------------------
}